import baseApi from "@/api/baseApi";
import { ContactPersonObject, PersonObject } from "@/types/userInterface";

const api = {
  async test() {
    const response = await baseApi.get("/user/test");
    return response.data;
  },
  async getContactPerson() {
    const response = await baseApi.get("/user/contactperson");
    return response.data;
  },
  async putContactPerson(contactperson: ContactPersonObject) {
    const response = await baseApi.put("/user/contactperson", contactperson);
    return response.data;
  },
  async addContactPerson(contactperson) {
    const response = await baseApi.post(
      "/user/contactperson/add",
      contactperson
    );
    return response.data;
  },

  async createContactPerson(person: PersonObject) {
    const response = await baseApi.post("/user/contactperson/create", person);
    return response.data;
  },

  async updateContactPersonContact(person) {
    const response = await baseApi.put(
      "/user/contact/contactperson/update",
      person
    );
    return response.data;
  },

  async setActive(contact) {
    const response = await baseApi.post("/user/setactive", contact);
    return response.data;
  },

  async putContactPersonHms(hms) {
    const response = await baseApi.put(`/user/contactperson/hms`, hms);
    return response.data;
  },
};

export default api;
